import {createTheme} from "@mui/material";

export const logoTheme = createTheme({
    typography: {
        fontFamily: [
            'STIX Two Text',
        ].join(','),
        fontWeight: 500
    }
})